<template>
  <el-form ref="businessSelectForm" :model="form" :rules="rules" label-width="25%" style="max-width: 600px" @submit.native.prevent="selectBusiness">
    <el-form-item label="Business" prop="businessId">
      <el-select v-model="form.businessId" placeholder="Business" v-loading="loading" filterable>
        <el-option v-for="business in businesses" :key="business.id" :value="business.id" :label="business.businessName" />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="selectBusiness">Select Business</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import find from 'lodash/find';
import api from '@/api';
import { Required } from '@/util/formValidators';

export default {
  data() {
    return {
      loading: false,
      businesses: [],
      form: {
        businessId: '',
      },
      rules: {
        businessId: [Required],
      },
    };
  },
  methods: {
    selectBusiness() {
      this.$refs.businessSelectForm.validate((valid) => {
        if (valid) {
          const business = find(this.businesses, { id: this.form.businessId });
          this.$emit('businessSelected', business);
        }
        return valid;
      });
    },
  },
  created() {
    this.loading = true;
    api.business.getBusinesses().then((response) => {
      this.businesses = response.data;
    }).finally(() => {
      this.loading = false;
    });
  },
};
</script>
